export default {
	DESKTOP: 992,
	TABLET: 768,
	PHONE: 376,
};
